// Ongles Lab 06/10/2026 (Valentin) : sur les cartes produit, « Red Crush - Extra-Court » s'affiche
// « Red Crush » puis la forme en dessous, comme dans le panier. Les titres sans « - » restent tels quels.
(function () {
  var SEL = 'product-card .text-block h2, product-card .text-block h3';
  function split(root) {
    (root || document).querySelectorAll(SEL).forEach(function (h) {
      if (h.dataset.olSplit) return;
      var t = h.textContent.trim(), i = t.lastIndexOf(' - '), name, shape;
      if (i > 0) { name = t.slice(0, i); shape = t.slice(i + 3); }
      else {
        // Titres sans « - » (ex. « Flower Coffin ») : forme reconnue en fin de titre, le nom reste entier (Emma, 06/10).
        var m = t.match(/(Extra[- ]court|Amande court|Carr[ée] court|Carr[ée]|Amande|Coffin)$/i);
        if (!m) return;
        name = t; shape = m[1].charAt(0).toUpperCase() + m[1].slice(1);
      }
      h.dataset.olSplit = '1';
      h.textContent = name;
      var s = document.createElement('span');
      s.className = 'ol-card-shape';
      s.textContent = shape;
      h.insertAdjacentElement('afterend', s);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { split(); });
  new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) split(n); }); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
